import { render, staticRenderFns } from "./UnlinkProductModal.vue?vue&type=template&id=35b2d2de&scoped=true&"
import script from "./UnlinkProductModal.vue?vue&type=script&lang=js&"
export * from "./UnlinkProductModal.vue?vue&type=script&lang=js&"
import style0 from "./UnlinkProductModal.vue?vue&type=style&index=0&id=35b2d2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2d2de",
  null
  
)

export default component.exports